import { Component, HostListener } from '@angular/core';

const NOTIFICATIONS = [
  {
    text: "Recuerde que el día 11/07/2023 vence su factura No. 829 con el afiliado Madecentro",
    read: false,
  },
  {
    text: "Le informamos que su negociación #xxxx fue rechazada",
    read: false,
  },
  {
    text: "Usted tiene una factura vencida con aviso de no pago (ver modulo historial facturas).",
    read: true,
  },
  {
    text: "Aun no usa su cupo con: Casa Toro. ¡Úselo ahora¡",
    read: true,
  },
  {
    text: "El cupo solicitado con Casa Toro fue aprobado.",
    read: true,
  },
  {
    text: "Usted tiene una factura vencida con aviso de no pago (ver modulo historial facturas).",
    read: true,
  },
  {
    text: "Aun no usa su cupo con: Casa Toro. ¡Úselo ahora¡",
    read: true,
  },
  {
    text: "El cupo solicitado con Casa Toro fue aprobado.",
    read: true,
  },
];

@Component({
  selector: 'app-notifications-button',
  templateUrl: './notifications-button.component.html',
  styleUrls: ['./notifications-button.component.scss']
})
export class NotificationsButtonComponent {

  public notificationsUnread = NOTIFICATIONS.filter((item) => !item.read).map(
    (item) => item.text
  );

  public notificationsRead = NOTIFICATIONS.filter((item) => item.read).map(
    (item) => item.text
  );

  public src: any = {
    iconOrder: this.notificationsUnread.length ? 'assets/img/icons/active-notifications.svg' : 'assets/img/icons/notifications.svg'
  }

  public message: string = `Ver todas las notificaciones (+${NOTIFICATIONS.length})`;

  public show: boolean = false;
  public clic: number = 0;

  @HostListener('click')
  clickInside() {
    this.clic++;
    this.show = this.clic % 2 === 0 ? false : true;
  }

  constructor() { }
}

